import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from '../../../api/axiosInstance';

export const getSingleBannerFunc = createAsyncThunk(
  "getSingleBanner",
  async (id, thunkAPI) => {
    try {
      const response = await api.get(`dashboard/general-settings/banners/${id}`);
      return response.data.data.banner;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || error.message);
    }
  }
);

const getSingleBannerSlicer = createSlice({
  name: "getSingleBanner",
  initialState: {
    loading: false,
    data: null,
    error: null,
    apiErrors: {},
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSingleBannerFunc.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.apiErrors = {};
      })
      .addCase(getSingleBannerFunc.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getSingleBannerFunc.rejected, (state, action) => {
        state.loading = false;
        state.error = true;
        state.apiErrors = action.payload?.errors || {};
      });
  },
});

export default getSingleBannerSlicer.reducer;
